import React, { useState, useEffect } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import fontSizes from '../common/fontSizes';

const SettingsDropdown = ({ layoutMode, onChangeLayoutMode, currentFontSize, onChangeFontSize }) => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const [isFullScreen, setIsFullScreen] = useState(false);

    const toggle = () => setIsOpen(prev => !prev);

    useEffect(() => {
        const onFsChange = () => setIsFullScreen(!!document.fullscreenElement);
        document.addEventListener('fullscreenchange', onFsChange);
        return () => document.removeEventListener('fullscreenchange', onFsChange);
    }, []);

    const handleFullscreen = () => {
        toggle();
        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen().catch(err =>
                console.error('Fullscreen request failed:', err)
            );
        } else {
            document.exitFullscreen();
        }
    };

    const handleDarkMode = () => {
        toggle();
        onChangeLayoutMode(layoutMode === 'dark' ? 'light' : 'dark');
    };

    const handleFont = () => {
        toggle();
        onChangeFontSize(currentFontSize === (fontSizes?.length - 1) ? 0 : currentFontSize + 1);
    };

    return (
        <Dropdown isOpen={isOpen} toggle={toggle} className="ms-1 header-item">
            <DropdownToggle
                tag="button"
                type="button"
                className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle shadow-none"
            >
                <i className="bx bx-cog fs-22"></i>
            </DropdownToggle>
            <DropdownMenu end>
                <DropdownItem tag="button" onClick={handleFullscreen}>
                    <i className={`${isFullScreen ? 'bx bx-exit-fullscreen' : 'bx bx-fullscreen'} me-2 fs-15 align-middle`}></i>
                    {isFullScreen ? t('settings.exitFullscreen') : t('settings.fullscreen')}
                </DropdownItem>
                <DropdownItem tag="button" onClick={handleDarkMode}>
                    <i className={`${layoutMode === 'dark' ? 'bx bx-sun' : 'bx bx-moon'} me-2 fs-15 align-middle`}></i>
                    {layoutMode === 'dark' ? t('settings.lightMode') : t('settings.darkMode')}
                </DropdownItem>
                <DropdownItem tag="button" onClick={handleFont}>
                    <i className="bx bx-font-size me-2 fs-15 align-middle"></i>
                    {t('settings.fontSize')}
                </DropdownItem>
            </DropdownMenu>
        </Dropdown>
    );
};

export default SettingsDropdown;
